export const delay = (timeInMilliseconds) => 
new Promise(resolve => setTimeout(resolve, timeInMilliseconds));